import styled from 'styled-components';

const ZoomImageStyled = styled.div`
  position: relative;
  z-index: 1;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  .ZoomImage {
    &__lens {
      position: absolute;
      z-index: 2;
      width: ${(props) => {
  var _a, _b;
  return (_b = (_a = props.lensConfig) == null ? void 0 : _a.width) != null ? _b : 200;
}}px;
      height: ${(props) => {
  var _a, _b;
  return (_b = (_a = props.lensConfig) == null ? void 0 : _a.height) != null ? _b : 200;
}}px;
      border: 2px solid #000000;
      cursor: ${(props) => props.isLoading ? "initial" : "none"};
      background-repeat: no-repeat;
      display: none;
      opacity: ${(props) => props.isLoading ? 0 : 1};
    }

    &__image {
      border-radius: 0;
    }
  }
`;

export { ZoomImageStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
